import { apiRequest } from "./service";
import { SHOP_ORDERS, SHOP_ORDER_RETURN, SHOP_RETURNABLE_ITEMS } from "./apiUrl";

// Reads the signed-in patient's orders from Shopify through our backend.
// `cursor` asks for the next page; omitted it returns the newest orders.
export const getShopOrdersApi = ({ token, limit, cursor }) =>
  apiRequest({
    apiUrl: SHOP_ORDERS,
    method: "GET",
    token,
    payload: cursor || limit ? { limit, cursor } : undefined,
  });

// What is still returnable on one order, so the patient can pick.
export const getReturnableItemsApi = ({ token, orderName }) =>
  apiRequest({
    apiUrl: SHOP_RETURNABLE_ITEMS,
    method: "GET",
    token,
    payload: { orderName },
  });

// Asks Shopify, through our backend, to open a return on one of the patient's
// own orders. The team approves or declines it in Shopify.
export const requestShopReturnApi = ({ token, orderName, reason, note, items }) =>
  apiRequest({
    apiUrl: SHOP_ORDER_RETURN,
    method: "POST",
    token,
    payload: { orderName, reason, note, items },
  });
